"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _emotion = require("emotion");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var buttonContainerStyle = (0, _emotion.css)(_templateObject());

var ConfigShippingView =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ConfigShippingView, _Component);

  function ConfigShippingView() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ConfigShippingView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ConfigShippingView)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      showDaysToDeliveryHelptText: false
    };

    _this.onClose = function () {
      var _this$props = _this.props,
          closeModal = _this$props.closeModal,
          onSubmit = _this$props.onSubmit;
      closeModal();
      onSubmit();
    };

    _this.showDaysToDeliveryHelptText = function () {
      _this.setState({
        showDaysToDeliveryHelptText: true
      });
    };

    _this.hideDaysToDeliveryHelptText = function () {
      _this.setState({
        showDaysToDeliveryHelptText: false
      });
    };

    return _this;
  }

  (0, _createClass2.default)(ConfigShippingView, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          shippingTime = _this$props2.shippingTime,
          onShippingTimeInputChange = _this$props2.onShippingTimeInputChange,
          deliveryLocations = _this$props2.deliveryLocations,
          ondeliveryLocationChange = _this$props2.ondeliveryLocationChange,
          selectedDeliveryLocation = _this$props2.selectedDeliveryLocation,
          onPostalCodeInputChange = _this$props2.onPostalCodeInputChange,
          postalCode = _this$props2.postalCode,
          closeModal = _this$props2.closeModal,
          onResetAll = _this$props2.onResetAll,
          open = _this$props2.open;
      return _react.default.createElement(_reactComponents.Modal, {
        className: "modal-custom-style",
        show: open,
        onRequestHide: closeModal,
        title: "Configure Shipping",
        closeButton: true
      }, _react.default.createElement("div", {
        className: "card card-custom-style"
      }, _react.default.createElement("div", {
        className: "card-block"
      }, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-md-10"
      }, _react.default.createElement(_reactComponents.Select, {
        label: "Ship To",
        value: selectedDeliveryLocation,
        options: deliveryLocations,
        onChange: ondeliveryLocationChange,
        required: true
      }))), _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-md-10"
      }, _react.default.createElement(_reactComponents.TextField, {
        label: "Postal Code",
        value: postalCode,
        onChange: onPostalCodeInputChange,
        disabled: !selectedDeliveryLocation,
        required: true
      }))), _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-md-10"
      }, _react.default.createElement(_reactComponents.Tooltip, {
        direction: "right",
        contents: "Shipping price will be calculated if Total Delivery Days greater than Production Time. ",
        show: this.state.showDaysToDeliveryHelptText
      }, _react.default.createElement(_reactComponents.TextField, {
        label: "Total Delivery Days",
        type: "number",
        value: shippingTime,
        onChange: onShippingTimeInputChange,
        disabled: !postalCode || !selectedDeliveryLocation,
        onFocus: this.showDaysToDeliveryHelptText,
        onBlur: this.hideDaysToDeliveryHelptText,
        required: true
      })))), _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "".concat(buttonContainerStyle, " col-md-12")
      }, _react.default.createElement(_reactComponents.Button, {
        type: "default",
        onClick: onResetAll
      }, "Reset"), _react.default.createElement(_reactComponents.Button, {
        type: "default",
        className: "submit-button-style",
        onClick: this.onClose,
        disabled: !shippingTime || !selectedDeliveryLocation || !postalCode
      }, "Submit"))))));
    }
  }]);
  return ConfigShippingView;
}(_react.Component);

exports.default = ConfigShippingView;